import React from "react";

import "./style.css";
/**
 * @param page  Render on the app background rather than dimming what is
 *   behind. Use it wherever the loader stands in for a whole screen, since
 *   there is nothing behind it to dim.
 */
const Loader = ({ page = false }: { page?: boolean }) => {
  return (
    <div className={`loader-container${page ? " loader-container--page" : ""}`}>
      <div className="loader">
        <div className="bouncer one" />
        <div className="bouncer two" />
        <div className="bouncer three" />
      </div>
    </div>
  );
};

export default Loader;
